import { type FC, useCallback } from 'react';
import type { ICustomFilter } from '../../../../../../helpers/helpers';
import RangeSliderFilter from '../../RangeSliderFilter';

const DomainsSlider: FC<ICustomFilter> = ({ onChange, isAdvancedFilter }) => {
  const filterName = isAdvancedFilter ? 'site_domains_filter_advanced' : 'site_domains_filter';
  const valueChangeCallback = useCallback(
    (value: string) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange],
  );

  return (
    <RangeSliderFilter
      filterName={filterName}
      minValue={1}
      maxValue={100}
      defaultValues={1}
      onChange={valueChangeCallback}
      isDual={false}
    />
  );
};

export default DomainsSlider;
